import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import HTTPService from "../../../../utils/axios";

const RewardManagement = () => {
  const [rewards, setRewards] = useState(null);
  const [loading, setLoading] = useState(true);
  const { invokeApi } = HTTPService();

  const fetchRewardData = async () => {
    invokeApi({
      method: "GET",
      url: "widget/reward-management",
    })
      .then((data) => {
        const allRewards = data || [];
        setRewards(allRewards.slice(0, 6));
      })
      .catch((error) => {
        console.error("Failed to fetch reward data", error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchRewardData();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-4">
        <Spinner animation="border" />
      </div>
    );
  }

  const getPriorityStyle = (priority) => {
    switch (priority) {
      case "P1":
        return { backgroundColor: "#DC3545", color: "white" }; // red
      case "P2":
        return { backgroundColor: "#fd7e14", color: "white" }; // orange
      case "P3":
        return { backgroundColor: "#E4A11B", color: "black" }; // yellow
      case "P4":
        return { backgroundColor: "#198754", color: "white" }; // green
      default:
        return { backgroundColor: "#6c757d", color: "white" }; // gray fallback
    }
  };

  return (
    <div className="px-0">
      <div className="border-0">
        <div className="card-body d-flex flex-column">
          <h4 className="mb-3 align-center">Reward Management</h4>
          <div
            className="table-responsive w-100"
            style={{ overflowY: "auto", overflowX: "auto", flex: 1 }}
          >
            <table className="table align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Program / Submission</th>
                  <th>Reward</th>
                  <th className="ps-3">Priority</th>
                  <th className="ps-3">Status</th>
                </tr>
              </thead>
              <tbody>
                {rewards.map((reward, idx) => (
                  <tr key={idx}>
                    <td
                      style={{
                        maxWidth: "200px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <h5
                        className="mb-1 text-primary"
                        style={{
                          fontSize: "18px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {reward.program_title}
                      </h5>
                      <p
                        className="mb-0 text-muted"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {reward.submission_title}
                      </p>
                    </td>

                    <td className="fw-bold text-success">
                      ${reward.rewards_amount}
                    </td>
                    <td className="ps-3">
                      <span
                        className="badge border"
                        style={{
                          ...getPriorityStyle(reward.priority),
                          padding: "0.5em 0.75em",
                          fontWeight: "500",
                          fontSize: "0.9em",
                        }}
                      >
                        {reward.priority}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          reward.note_status === "submitted"
                            ? "bg-success"
                            : reward.note_status === "pending"
                            ? "bg-secondary"
                            : "bg-danger"
                        }`}
                      >
                        {reward.note_status === "submitted"
                          ? "success"
                          : reward.note_status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {rewards.length === 0 && (
              <p className="text-center text-muted py-3">No rewards found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardManagement;
